import { useMemo } from 'react'

import { getCountdown, type CountdownParts } from '@/lib/countdown'

import { useNow } from './useNow'

/** Live countdown to an ISO instant, recomputed once a second. */
export function useCountdown(targetIso: string): CountdownParts {
  const now = useNow(1000)
  const targetMs = useMemo(() => new Date(targetIso).getTime(), [targetIso])

  return useMemo(() => getCountdown(targetMs, now), [targetMs, now])
}
